export default "__VITE_ASSET__B7uhE1BA__"